export function required(source1, source2, source3) {
    return merge([source1, source2, source3], (p, e) => {
        return { ...p, ...e };
    });
}
export function requiredDeep(source1, source2, source3) {
    return merge([source1, source2, source3], (p, e) => deepmerge(p, e));
}
function merge(entries, reducer) {
    if (entries[0] === undefined || entries[0] === null)
        return entries[0];
    return entries.filter(x => !!x).reduce(reducer, {});
}
function deepmerge(source1, source2) {
    if (typeof source1 !== 'object' || source1 === null)
        return source2 !== undefined ? source2 : source1;
    if (Array.isArray(source1)) {
        if (Array.isArray(source2))
            return source2;
        if (source2 === undefined)
            return [...source1];
        return [...source1, source2];
    }
    return getAllKeys(source1).concat(getAllKeys(source2)).reduce((p, k) => {
        // @ts-ignore
        p[k] = deepmerge(source1[k], source2 && source2[k]);
        return p;
    }, {});
}
function getAllKeys(subject, internal = false) {
    if (typeof subject !== 'object')
        return [];
    const propertyNames = Object.getOwnPropertyNames(subject);
    const keys = internal ? propertyNames.filter(n => n !== 'constructor') : propertyNames;
    const proto = Object.getPrototypeOf(subject);
    return proto !== Object.prototype ? keys.concat(getAllKeys(proto, true)) : keys;
}
export function unpartial(s1, s2, s3) {
    // defensive check for JS
    if (s1 === undefined || s1 === null)
        return s1;
    return [s1, s2, s3]
        .filter(notNil)
        .reduce((p, s) => ({ ...p, ...trimNilProps(s) }), {});
}
function trimNilProps(value) {
    return Object.keys(value).reduce((p, k) => {
        if (notNil(value[k]))
            p[k] = value[k];
        return p;
    }, {});
}
function notNil(value) {
    return value !== null && value !== undefined;
}
export function unpartialRecursively(arg1, arg2, arg3) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return requiredDeep(arg1, arg2, arg3);
}
//# sourceMappingURL=index.js.map